import { FORM_MODES } from "routes/campaign/form/defaults";

export const MODEL_TYPE = "Campaign";

export const PAGE_TITLES = {
  [FORM_MODES.create]: "Create Campaign",
  [FORM_MODES.edit]: "Edit Campaign",
};

export const BREADCRUMB_LABELS = {
  [FORM_MODES.create]: "New",
  [FORM_MODES.edit]: "Edit",
};

export const SUCCESS_MESSAGES = {
  [FORM_MODES.create]: "Campaign created",
  [FORM_MODES.edit]: "Campaign updated",
};
